import { render, staticRenderFns } from "./photoItem.vue?vue&type=template&id=83359226"
import script from "./photoItem.vue?vue&type=script&lang=js"
export * from "./photoItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports